export const SIDEBAR_HERO_TEXT_MAX_HEIGHT = 600;
export const SIDEBAR_HERO_TEXT_MIN_VIEWPORT_WIDTH = 1024;

export function resolveSidebarHeroTextMaxHeight({
    rail,
    textElement,
    maxHeight = SIDEBAR_HERO_TEXT_MAX_HEIGHT,
    minViewportWidth = SIDEBAR_HERO_TEXT_MIN_VIEWPORT_WIDTH,
}) {
    if (typeof window === "undefined") return maxHeight;
    if (window.innerWidth < minViewportWidth) return null;
    if (!rail || !textElement) return maxHeight;

    const railRect = rail.getBoundingClientRect();
    const railStyle = window.getComputedStyle(rail);
    const railPaddingTop = parseFloat(railStyle.paddingTop) || 0;
    const railPaddingBottom = parseFloat(railStyle.paddingBottom) || 0;
    const availableHeight = railRect.height
        - railPaddingTop
        - railPaddingBottom
        - getSidebarItemsOutsideTextHeight(textElement)
        - getSiblingTextContainerItemsHeight(textElement)
        - getElementsAfterTextHeight(textElement);

    return Math.max(0, Math.min(maxHeight, Math.floor(availableHeight)));
}

function getSidebarItemsOutsideTextHeight(textElement) {
    const textColumn = textElement.closest(".col");
    const sidebarContent = textElement.closest(".ufo-sec--hero");
    if (!textColumn || !sidebarContent) return 0;

    const sidebarItem = getDirectChildOf(textColumn, sidebarContent);
    if (!sidebarItem) return 0;

    const sidebarItems = getVisibleElementChildren(sidebarContent);
    const sidebarGap = getRowGap(sidebarContent);
    const gapHeight = Math.max(0, sidebarItems.length - 1) * sidebarGap;
    const siblingHeight = sidebarItems
        .filter((element) => element !== sidebarItem)
        .reduce((height, element) => height + element.getBoundingClientRect().height, 0);

    return siblingHeight + gapHeight;
}

function getSiblingTextContainerItemsHeight(textElement) {
    const textColumn = textElement.closest(".col");
    const sidebarContent = textElement.closest(".ufo-sec--hero");
    const sidebarItem = textColumn && sidebarContent
        ? getDirectChildOf(textColumn, sidebarContent)
        : null;

    if (!textColumn || !sidebarItem || textColumn === sidebarItem) return 0;

    const containerItems = getVisibleElementChildren(sidebarItem);
    const containerGap = getRowGap(sidebarItem);
    const gapHeight = Math.max(0, containerItems.length - 1) * containerGap;
    const siblingHeight = containerItems
        .filter((element) => element !== textColumn)
        .reduce((height, element) => height + element.getBoundingClientRect().height, 0);

    return siblingHeight + gapHeight;
}

function getDirectChildOf(element, parent) {
    let current = element;

    while (current?.parentElement && current.parentElement !== parent) {
        current = current.parentElement;
    }

    return current?.parentElement === parent ? current : null;
}

function getElementsAfterTextHeight(textElement) {
    const textColumn = textElement.closest(".col");
    if (!textColumn) return 0;

    return Array.from(textColumn.querySelectorAll(".actions-row, .navbar-inline"))
        .reduce((height, element) => height + element.getBoundingClientRect().height, 0);
}

function getVisibleElementChildren(element) {
    return Array.from(element.children)
        .filter((child) => child.getBoundingClientRect().height > 0);
}

function getRowGap(element) {
    const styles = window.getComputedStyle(element);
    return parseFloat(styles.rowGap || styles.gap) || 0;
}
